import { render, staticRenderFns } from "./split-apply-info.vue?vue&type=template&id=acd511da&scoped=true"
import script from "./split-apply-info.vue?vue&type=script&lang=js"
export * from "./split-apply-info.vue?vue&type=script&lang=js"
import style0 from "./split-apply-info.vue?vue&type=style&index=0&id=acd511da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd511da",
  null
  
)

export default component.exports